import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Typography,
  Box,
} from '@material-ui/core';

import useStyles from './styles';
import Button from '../../components/Button';

const LocationDeleteDialog = ({ locationId, handleDelete, setOpenDeleteDialog }) => {
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <div className={styles.formWrapper}>
      <Box className={styles.modalBox}>
        <Typography>
          {t('locations.delete.paragraph')}
        </Typography>
        <br />
        <Box className={styles.buttonsBox} >
          <Button
            height="35px"
            width="130px"
            backgroundColor="#E74C3C"
            color="white"
            borderRadius="10px"
            onClick={() => setOpenDeleteDialog(false)}
            text={t('common.cancel')}
          />
          <Button
            height="35px"
            width="130px"
            backgroundColor="#2C9DC9"
            color="white"
            borderRadius="10px"
            onClick={() => handleDelete(locationId)}
            text={t('common.accept')}
          />
        </Box>
      </Box>
    </div >
  );
};

export default LocationDeleteDialog;
